import React from 'react';
import { DateTime } from 'luxon';

import { withStyles } from '@material-ui/core/styles';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTooltip from '@material-ui/core/Tooltip';
import MuiAvatar from '@material-ui/core/Avatar';

import RowButtons from './row-buttons';

const styles = theme => ({
  buttonCell: {
    whiteSpace: 'nowrap',
  },
});

const Row = props => {
  const { classes, row, onEditChange, editing } = props;

  return (
    <MuiTableRow className={classes.root}>
      <MuiTableCell>{row.release?.title}</MuiTableCell>
      <MuiTableCell>{row.dsp}</MuiTableCell>
      <MuiTableCell>{row.upc}</MuiTableCell>
      <MuiTableCell>{row.ern_type}</MuiTableCell>
      <MuiTableCell>{row.status}</MuiTableCell>
      <MuiTableCell>
        {row.started_at
          ? DateTime.fromISO(row.started_at).toLocaleString({
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })
          : ''}
        <br />
        {row.completed_at
          ? DateTime.fromISO(row.completed_at).toLocaleString({
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })
          : ''}
      </MuiTableCell>
      <MuiTableCell>
        {row?.queueEntry?.deliveredBy && (
          <MuiTooltip title={row.queueEntry.deliveredBy.email}>
            <MuiAvatar alt={row.queueEntry.deliveredBy.name}>
              {row.queueEntry.deliveredBy.name?.charAt(0) || row.queueEntry.deliveredBy.email?.charAt(0)}
            </MuiAvatar>
          </MuiTooltip>
        )}
      </MuiTableCell>
      <MuiTableCell className={classes.buttonCell} align="right">
        <RowButtons
          rowId={row.id}
          editing={editing}
          onEditChange={onEditChange}
          releaseId={row.asset_release_id}
          status={row.status}
        />
      </MuiTableCell>
    </MuiTableRow>
  );
};

export default withStyles(styles)(Row);
